import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import "./Changepassword.css";
import CommonButton from "../../../../Componants/Common/Button";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import { Grid } from "@mui/material";
import { changePassword } from "../../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import PasswordTab from "../../../../Componants/Common/PasswordTab";

const Changepassword = () => {
  const [value, setValue] = useState({});
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    console.log(`Field: ${field}, Value: ${value}`); 
    setPasswords((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleChangePassword = async () => {
    const { oldPassword, newPassword, confirmPassword } = passwords;

    // Input Validation
    if (!oldPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required.");
      // alert("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      // alert("New password and confirm password do not match.");
      return;
    }

    setLoading(true);

    try {
      const response = await changePassword(passwords);

      if (response.status === "success") {
        toast.success(response.message || "Password changed successfully!");
        // alert(response.message || "Password changed successfully!");
        setPasswords({ oldPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        toast.error(response.message || "Failed to change password.");
        // alert(response.message || "Failed to change password.");
      }
    } catch (error) {
      console.error("Error during password change:", error);
      toast.error("An error occurred while changing the password.");
      // alert("An error occurred while changing the password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-Changepassword">
      <HeaderNavigation value={"Change Password"} />
      <PasswordTab/>
      <div className="textfiled-Changepassword">
        <div className="line-Changepassword">
          <div className="textinput-Changepassword">
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Old Password"
              variant="standard"
              value={passwords.oldPassword}
              onChange={(e) => handleInputChange("oldPassword", e.target.value)}
            />
          </div>
          <div className="textinput-Changepassword">
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="New Password"
              variant="standard"
              value={passwords.newPassword}
              onChange={(e) => handleInputChange("newPassword", e.target.value)}
            />
          </div>

          <div className="textinput-Changepassword">
            {" "}
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Confirm Password*"
              variant="standard"
              value={passwords.confirmPassword}
              onChange={(e) =>
                handleInputChange("confirmPassword", e.target.value)
              }
            />
          </div>
        </div>
        <Grid container sx={{ margin: "10px" }}>
          <CommonButton
            name={"Change Password"}
            handleOnClick={handleChangePassword}
          />
        </Grid>

        <div className="button-Changepassword">
          <div className="textinput-Changepassword"></div>
        </div>
      </div>
      <Toaster />
      {loading && <Loader/>}
    </div>
  );
};

export default Changepassword;
